import React, { Component } from "react";
import config from "lib/fr-config";
import TextButtonView from "presentational/common/TextButtonView";
import { getDeviceType } from "lib/deviceInfo";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import PropTypes from "prop-types";

const commonCss = config.css.commonDevice;
const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

const TOP_OUTER_PADDING = 34;
const BOTTOM_OUTER_PADDING = 20;
const SIDE_OUTER_PADDING = 34;
const PADDING_BETWEEN_CONTENT = 24;
const DIVIDER_MARGIN = 10;

const TOP_AND_BOTTOM_LIST_BTN_PADDING =
  commonCss.listItemBtn.topAndBottomPaddingOfBtn;
const SIDE_LIST_BTN_PADDING = commonCss.listItemBtn.sidePaddingOfBtn;

const CustomDialog = withStyles({
  paper: {
    maxWidth: 600,
    margin: 0
  }
})(Dialog);
const CustomDialogTitle = withStyles({
  root: {
    padding: `${TOP_OUTER_PADDING}px ${SIDE_OUTER_PADDING}px ${PADDING_BETWEEN_CONTENT}px`
  }
})(DialogTitle);
const CustomDialogContent = withStyles({
  root: {
    padding: `0 ${SIDE_OUTER_PADDING}px`,
    marginBottom: PADDING_BETWEEN_CONTENT,
    "&:first-child": { paddingTop: `${TOP_OUTER_PADDING}px` }
  }
})(DialogContent);
const CustomDialogContentText = withStyles({
  root: { display: "flex", justifyContent: "center", margin: 0 }
})(DialogContentText);
const CustomDialogActions = withStyles({
  root: {
    margin: `${0}px ${SIDE_OUTER_PADDING}px ${BOTTOM_OUTER_PADDING}px`,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap"
  }
})(DialogActions);
const CustomList = withStyles({
  root: {
    marginLeft: -SIDE_LIST_BTN_PADDING,
    marginRight: -SIDE_LIST_BTN_PADDING,
    padding: 0
  }
})(List);
const CustomListItem = withStyles({
  root: {
    padding: `${TOP_AND_BOTTOM_LIST_BTN_PADDING}px ${SIDE_LIST_BTN_PADDING}px`
  }
})(ListItem);
const CustomListItemText = withStyles({
  root: { margin: 0 },
  primary: {
    lineHeight: 1.4,
    fontSize:
      getDeviceType() === "mobile"
        ? mobileCss.fontSizeOfTextBtn
        : desktopCss.fontSizeOfTextBtn
  },
  secondary: {
    lineHeight: 1.4,
    fontSize:
      getDeviceType() === "mobile"
        ? mobileCss.fontSizeOfTextBtn - 2
        : desktopCss.fontSizeOfTextBtn - 2
  }
})(ListItemText);
const CustomDivider = withStyles({
  root: {
    margin: `${DIVIDER_MARGIN}px ${0}px`
  }
})(Divider);

class CommonModalView extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,

    fullScreen: PropTypes.bool,
    paperStyle: PropTypes.object,
    titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    contentStyle: PropTypes.object,
    contentComponent: PropTypes.object,
    contentText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    buttonList: PropTypes.arrayOf(
      PropTypes.shape({
        primary: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        secondary: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        func: PropTypes.func
      })
    ),
    firstButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    firstButtonTextColor: PropTypes.string,
    firstButtonFunc: PropTypes.func,
    firstButtonDisabled: PropTypes.bool,
    secondButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    secondButtonTextColor: PropTypes.string,
    secondButtonFunc: PropTypes.func,
    secondButtonDisabled: PropTypes.bool,

    removeAllBtn: PropTypes.bool
  };

  static defaultProps = {
    fullScreen: false,
    paperStyle: {},
    contentStyle: {},
    contentComponent: null,
    firstButtonTextColor: null,
    firstButtonDisabled: false,
    secondButtonTextColor: null,
    secondButtonDisabled: false,

    removeAllBtn: false
  };

  getButtonList() {
    const { buttonList } = this.props;

    return (
      <CustomList>
        {buttonList.map((unit, index) => {
          if (unit.divider) {
            return <CustomDivider key={`divider-${index}`} />;
          }

          return (
            <CustomListItem button key={`button-${index}`} onClick={unit.func}>
              <CustomListItemText
                primary={unit.primary}
                secondary={unit.secondary}
              ></CustomListItemText>
            </CustomListItem>
          );
        })}
      </CustomList>
    );
  }

  render() {
    const {
      open,
      fullScreen,
      paperStyle,
      titleText,
      contentStyle,
      contentComponent,
      contentText,
      buttonList,
      firstButtonText,
      firstButtonTextColor,
      firstButtonFunc,
      firstButtonDisabled,
      secondButtonText,
      secondButtonTextColor,
      secondButtonFunc,
      secondButtonDisabled,
      onClose,
      removeAllBtn
    } = this.props;

    return (
      <CustomDialog
        open={open}
        onClose={onClose}
        scroll="paper"
        fullScreen={fullScreen}
        PaperProps={{ square: true, elevation: 0, style: paperStyle }}
        transitionDuration={config.css.animation.modalDurationMilliSec}
      >
        {titleText && <CustomDialogTitle>{titleText}</CustomDialogTitle>}
        <CustomDialogContent style={contentStyle}>
          {contentText && (
            <CustomDialogContentText>{contentText}</CustomDialogContentText>
          )}
          {contentComponent}
          {buttonList && this.getButtonList()}
        </CustomDialogContent>
        {!removeAllBtn && (
          <CustomDialogActions>
            {firstButtonText && (
              <TextButtonView
                fontColor={firstButtonTextColor || undefined}
                onClick={firstButtonFunc}
                disabled={firstButtonDisabled}
                paddingSize="large"
                design="default"
                disableRightMargin={!secondButtonText}
              >
                {firstButtonText}
              </TextButtonView>
            )}
            {secondButtonText && (
              <TextButtonView
                fontColor={secondButtonTextColor || undefined}
                onClick={secondButtonFunc}
                disabled={secondButtonDisabled}
                paddingSize="large"
                design="default"
                disableRightMargin
              >
                {secondButtonText}
              </TextButtonView>
            )}
          </CustomDialogActions>
        )}
      </CustomDialog>
    );
  }
}

export default CommonModalView;
